// extracted by mini-css-extract-plugin
export default {"formControlWrapper":"AutoSuggestInput_formControlWrapper__jLKGT","saveforLetterBtn":"AutoSuggestInput_saveforLetterBtn__5miof"};